import React from 'react'
import AxiomaContainer from 'src/container/AxiomaContainer/AxiomaContainer.jsx'


const AxiomaAuditorContainer = () => (
    <div>
      <AxiomaContainer isAuditorData />
    </div>
  )

export default AxiomaAuditorContainer
